import { motion } from 'framer-motion';
import { customerProfile, bookingHistory } from '../../../mocks/bookingHistory';

export default function ProfileHeader() {
  const completedTrips = bookingHistory.filter(b => b.status === 'completed').length;
  const upcomingTrips = bookingHistory.filter(b => b.status === 'upcoming').length;

  return (
    <section className="mb-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden"
      >
        {/* Banner */}
        <div className="relative h-36 sm:h-44 overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/2254b9dc20c944e8f0d2f7943d6ae35e.jpg"
            alt="Panorama des Alpes françaises en hiver"
            title="Voyage Elite - Mon Compte"
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
        </div>

        {/* Profile info */}
        <div className="px-6 sm:px-8 pb-6 sm:pb-8 -mt-12 relative z-10">
          <div className="flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-6">
            {/* Avatar */}
            <div className="w-24 h-24 bg-gradient-to-br from-voyage-gold to-amber-500 rounded-2xl flex items-center justify-center text-white font-playfair font-bold text-4xl shadow-xl border-4 border-white flex-shrink-0">
              {customerProfile.name.charAt(0)}
            </div>

            <div className="flex-1">
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <h1 className="font-playfair text-2xl sm:text-3xl font-bold text-night-blue">
                  {customerProfile.name}
                </h1>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-voyage-gold/15 text-voyage-gold rounded-full font-inter text-xs font-bold uppercase tracking-wider w-fit">
                  <i className="ri-vip-crown-2-fill text-sm"></i>
                  {customerProfile.status}
                </span>
              </div>
              <p className="text-slate-500 font-inter text-sm mt-1">
                Membre depuis {new Date(customerProfile.memberSince).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
              </p>
            </div>

            <a
              href="/reservation"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-voyage-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-sm hover:shadow-lg hover:scale-105 transition-all cursor-pointer whitespace-nowrap self-start sm:self-auto"
            >
              <i className="ri-add-line text-lg"></i>
              Nouvelle réservation
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 pt-6 border-t border-slate-100">
            <div className="text-center sm:text-left">
              <div className="font-playfair text-2xl sm:text-3xl font-bold text-night-blue">{completedTrips}</div>
              <div className="font-inter text-xs text-slate-500 mt-0.5">Transferts effectués</div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-playfair text-2xl sm:text-3xl font-bold text-voyage-gold">{upcomingTrips}</div>
              <div className="font-inter text-xs text-slate-500 mt-0.5">À venir</div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-playfair text-2xl sm:text-3xl font-bold text-night-blue">{customerProfile.totalSpent.toLocaleString('fr-FR')}€</div>
              <div className="font-inter text-xs text-slate-500 mt-0.5">Total dépensé</div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-playfair text-2xl sm:text-3xl font-bold text-night-blue flex items-center justify-center sm:justify-start gap-1">
                <i className="ri-heart-fill text-red-400 text-xl"></i>
                {customerProfile.favoriteDestination}
              </div>
              <div className="font-inter text-xs text-slate-500 mt-0.5">Destination favorite</div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
